<div class="border border-outline dark:border-outline-darkmode rounded-lg overflow-hidden">
  <div class="flex">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
  <div class="flex border-t border-outline dark:border-outline-darkmode">
    <div
      class="flex-none size-18 flex items-center justify-center border-r border-outline dark:border-outline-darkmode"
    >
      <ui-skeleton class="size-6 block rounded-full" />
    </div>
    <div class="flex-1 flex flex-col justify-center gap-2 px-6">
      <ui-skeleton class="h-3 w-[314px] block rounded-full" />
      <ui-skeleton class="h-3 w-full block rounded-full" />
    </div>
  </div>
</div>
